/**
 *  @class
 *  @function FreeShipping
 *
 *  Defers updates until `formatMoney` exists (from vendor.min.js), because this file
 *  is often included above vendor in the cart section and connectedCallback can run first.
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this._applyWhenReady(0);
    }

    _applyWhenReady(attempt) {
      if (typeof formatMoney !== 'function') {
        if (attempt > 80) {
          return;
        }
        setTimeout(() => this._applyWhenReady(attempt + 1), 16);
        return;
      }
      this._apply();
    }

    _apply() {
      let amount_text = this.querySelector('.free-shipping--text-remaining span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimumBase = parseInt(this.dataset.minimum, 10);
      let rate =
        typeof Shopify !== 'undefined' &&
        Shopify.currency &&
        typeof Shopify.currency.rate === 'number' &&
        !isNaN(Shopify.currency.rate)
          ? Shopify.currency.rate
          : 1;
      let minimum = Math.round(minimumBase * rate);
      if (isNaN(total) || isNaN(minimum) || minimum <= 0) {
        this.style.setProperty('--percentage', 0);
        return;
      }

      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total;
          let format =
            (window.theme &&
              window.theme.settings &&
              window.theme.settings.money_with_currency_format) ||
            '${{amount}}';
          amount_text.innerHTML = formatMoney(remaining, format);
        }
        if (this.remainingText) this.remainingText.style.display = 'block';
        if (this.fullText) this.fullText.style.display = 'none';
      } else {
        if (this.remainingText) this.remainingText.style.display = 'none';
        if (this.fullText) this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
    }
  }
  customElements.define('free-shipping', FreeShipping);
}
